"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable indent, @typescript-eslint/indent */
var React = require("react");
// TODO: mapAjaxToProps doesn't refetch on prop updates. We should
// implement that, giving consumers a way to determine if an update requires a refetch
var mapAJAXToProps = function (fetcher) { return function (Component, name) {
    var _a;
    var result = (_a = /** @class */ (function (_super) {
            tslib_1.__extends(Connected, _super);
            function Connected() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Connected.prototype.componentDidMount = function () {
                var _this = this;
                var req = fetcher(this.props);
                req.then(function (res) {
                    _this.setState(res);
                });
            };
            Connected.prototype.render = function () {
                return React.createElement(Component, tslib_1.__assign({}, this.props, this.state));
            };
            return Connected;
        }(React.Component)),
        _a.displayName = "AJAX" + name,
        _a.WrappedComponent = Component,
        _a);
    return result;
}; };
exports.default = mapAJAXToProps;
//# sourceMappingURL=map_ajax_to_props.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/map_ajax_to_props.js
// module id = 92m9
// module chunks = 20 21 22